module.exports = __webpack_public_path__ + "static/airmason_logo_dark-12ab850a379c154bc0bfe4dc3b43fa2a.svg";